"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getScrollableParent", {
    enumerable: true,
    get: function() {
        return getScrollableParent;
    }
});
const getScrollableParent = (node)=>{
    if (node == null) {
        return null;
    }
    try {
        if (node.scrollHeight > node.clientHeight) {
            return node;
        } else {
            return getScrollableParent(node.parentNode);
        }
    } catch  {
        return null;
    }
};

//# sourceMappingURL=getScrollableParent.js.map